export enum STATUS {
  DEFAULT = "default",
  SUCCESS = "success",
  WARNING = "warning",
}
